import React, { useState, useEffect } from "react";

export const Scrollindicator = () => {
  const [scrolled, setScrolled] = useState(0);
  const [offsetY, setOffsetY] = useState(0);

  // Below function and useEffect for calculating the pageYOffset;
  const handleScroll = () => {
    const position = window.pageYOffset;
    setOffsetY(position);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // console.log(Math.ceil(scrolled));
  //End of the calculating pageYOffset;

  //This useEffect for calculating the page scrolling height in parcentage;
  useEffect(() => {
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    setScrolled((offsetY / height) * 100);
  }, [offsetY]);

  return (
    <div id="percentage-value" data-aos="zoom-in-down">
      <div>
        <p>Scrolled</p>
        <p>{Math.ceil(scrolled) >= 100 ? 100 : Math.ceil(scrolled)}%</p>
      </div>
    </div>
  );
};
